module.exports = __webpack_public_path__ + "static/img/delong1.80502d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/delong1.jpg
// module id = BtW4
// module chunks = 0